export default "__VITE_ASSET__Cz3UMnxk__"